import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { AdminAuthService } from './admin-auth.service'

export const adminAuthGuard: CanActivateFn = () => {
  const auth = inject(AdminAuthService)
  const router = inject(Router)

  if (auth.isAuthenticated()) {
    return true
  }

  return router.parseUrl('/login')
}
